<template>
    <div class="filters-popup filter-wrapper">
        <div :class="{ 'col-12 offset-1': width > 1200, 'mx-2': width <= 1200 }">
            <div class="card no-border border-10 shadow">
                <div class="card-body">
                <div v-if="mode === 'filterAllArtist'">
                    <div v-if="priceValue" class="col-12" id="cost">
                        <div class="row pb-5">
                            <div class="col-12">
                                <h3>ARTIST PAYOUT</h3>
                            </div>
                        </div>
                        <div class="row pb-4">
                            <div class="col-12">
                                <veeno id="filter-cost"
                                    pipsy tooltips connect
                                    :handles="[parseInt(filter.min), parseInt(filter.max)]"
                                    :range="{'min': parseInt(filter.min), 'max': parseInt(filter.max) }"
                                    @set="sliderEvent()"
                                    @end="sliderEvent()">
                                </veeno>
                            </div>
                        </div>
                        <div class="row text-filters price-filters">
                            <div class="col-6 text-start">
                                <span>${{ filterBudget.min }}</span>
                            </div>
                            <div class="col-6 text-end">
                                <span>${{ filterBudget.max }}</span>
                            </div>
                        </div>
                    </div>
                <div class="d-flex">
                    <div class="js-filter-fanbase-container filters-margin-button col-12 col-md-5 pe-0">
                        <div class="row mb-2">
                            <div class="col-12">
                                <h3>FAN BASE</h3>
                             </div>
                        </div>

                        <div class="row">
                            <div class="col-12 text-filters">
                                <div class="d-flex form-check pb-3">
                                    <input class="form-check-input  checkmark js-choose" type="radio"
                                        value="1000" name="fan_base" id="fanbase-level-1" v-model="filterArtist.fanBaseValue">
                                    <label class="form-check-label px-3 mt-2" for="fanbase-level-1">0-1,000</label>
                                </div>

                                <div class="d-flex form-check pb-3">
                                    <input class="form-check-input checkmark js-choose" type="radio"
                                        value="value2" name="fan_base" id="fanbase-level-2" v-model="filterArtist.fanBaseValue">
                                    <label class="form-check-label px-3 mt-2" for="fanbase-level-2">1,000-10,000</label>
                                </div>

                                <div class="d-flex form-check pb-3">
                                    <input class="form-check-input checkmark js-choose" type="radio"
                                        value="10000" name="fan_base" id="fanbase-level-3" v-model="filterArtist.fanBaseValue">
                                    <label class="form-check-label px-3 mt-2" for="fanbase-level-3">10,000+</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="filter-artist-ranking-container filters-margin-button col-12 col-md-7">
                        <div class="row mb-2">
                            <div class="col-12">
                                <h3>ARTIST RANKING</h3>
                            </div>
                        </div>

                        <div class="row scroll-blocks-input" v-for="(ranking, index) in unicArtistRanking" :key="index">
                            <div class="col-12 main-text">
                                <div class="d-flex form-check pb-3 text-filters">
                                        <input class="form-check-input checkmark js-choose" type="radio" :value="ranking"
                                            name="rank" v-model="filterArtist.artistRanking" @change="artistsRanking(ranking)">
                                        <label class="form-check-label px-3 mt-2">
                                            {{ ranking }}
                                        </label>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>

                    <div class="row pb-3">
                        <div class="col-12">
                            <button type="button" @click="clearArtistFilter()"
                                    class="btn-underline btn main-text filters-link text-purple px-0">
                                Clear Filters
                            </button>
                        </div>
                    </div>
                        <div class="row justify-content-start align-items-center mb-2">
                            <div class="col-12 d-flex justify-content-start align-content-center">
                            <button type="button" class="js-filters-cancel filters-cancel button-text" @click="cancelFilter">Cancel</button>
                            <button type="button" @click="applyArtistFilter()"
                                class="button-text text-white h-50px w-150px bg-purple btn-shadow btn border-50">Apply</button>
                        </div>
                    </div>
                </div>
                <div v-if="mode !== 'filterAllArtist'">
                    <form id="filters-form" class="row ps-1 pe-3">
                        <div class="col-12">
                            <h3> SOUND </h3>
                            <input type="text" name="sound" v-model="filter.sound" placeholder="Sound" class="w-100">
                        </div>
                        <div class="col-12" id="cost">
                            <div class="row pb-4">
                                <div class="col-12">
                                    <h3>ARTIST PAYOUT</h3>
                                </div>
                            </div>
                            <div class="row pb-4">
                                <div class="col-12">
                                    <veeno id="filter-cost"
                                           pipsy tooltips connect
                                           :handles="[parseInt(filter.min), parseInt(filter.max)]"
                                           :range="{'min': parseInt(filter.min), 'max': parseInt(filter.max) }"
                                           @set="sliderEvent()"
                                           @end="sliderEvent()"></veeno>
                                </div>
                            </div>
                            <div class="row text-filters price-filters">
                                <div class="col-6 text-start">
                                    <span>${{ filterBudget.min }}</span>
                                </div>
                                <div class="col-6 text-end">
                                    <span>${{ filterBudget.max }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row mb-2">
                                <div class="col-12">
                                    <h3>Location</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 text-filters mb-4">
                                    <input type="text"
                                           v-model="filter.location"
                                           placeholder="Location"
                                           ref="location"
                                           name="location"
                                           id="address-bid"
                                           :class="{ 'is-invalid' : errors.location,  'is-invalid' : errors.lat }"
                                           class="group-input form-control border-50 py-4">
                                    <span class="invalid-feedback" role="alert"
                                          v-if="errors.lat && !errors.location"><strong>{{
                                            errors.lat[0]
                                        }}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="row mb-2">
                                <div class="col-12">
                                    <h3>Travel Radius</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 main-text mb-4">
                                    <div class="custom-number-input-wrapper" @mouseenter="customNumberInit">
                                        <div class="form-input-border input-group border-50">
                                            <div class="col-2 d-flex justify-content-center align-items-center">
                                                <span class="main-text-bold">Mi</span>
                                            </div>
                                            <div class="col-10">
                                                <input
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    max="1000"
                                                    name="radius"
                                                    v-model="filter.radius"
                                                    placeholder="Radius"
                                                    :class="{ 'is-invalid' : errors.radius }"
                                                    class="form-control w-100 custom-arrows radius-input group-input border-50 py-4">
                                                <div class="row number-input-controls-container">
                                                    <div class="col-2 d-flex input-controls px-4">
                                                        <div class="input-controls-wrapper row mx-3 py-3">
                                                            <div ref="price-upper"
                                                                 class="js-number-input-upper custom-number-input-upper-arrow">
                                                                <img
                                                                    src="images/icons/number-input-upper.png"
                                                                    alt="increase value">
                                                            </div>
                                                            <div ref="price-lower"
                                                                 class="js-number-input-lower custom-number-input-lower-arrow">
                                                                <img
                                                                    src="images/icons/number-input-lower.png"
                                                                    alt="decrease value">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="row mb-2">
                                <div class="col-12">
                                    <h3>Date</h3>
                                </div>
                            </div>
                            <div class="row">
                                <date-picker v-model="filter.date" class="col-12 main-text w-100"
                                             valueType="format"
                                             placeholder="Event Date"
                                             format="MMM-DD-YYYY"></date-picker>
                            </div>
                        </div>

                        <div class="col-12 mb-2">
                            <div class="row mb-2">
                                <div class="col-12">
                                    <h3>Artist requirements</h3>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 main-text mb-2">
                                    <input class="form-check-input checkmark-bids" type="checkbox" v-model="filter.bring_equipment"
                                           name="equipment" id="bring_equipment">
                                    <label class="form-check-label px-3 mt-2 text-filters" for="artist-requirement">
                                        Brings own sound equipment/engineer
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row pb-3">
                            <div class="col-12">
                                <button type="button" @click="clearFilter()"
                                        class="btn-underline btn main-text filters-link text-purple px-0">
                                    Clear Filters
                                </button>
                            </div>
                        </div>

                        <div class="row justify-content-start align-items-center mb-2">
                            <div class="col-12 d-flex justify-content-start align-content-center">
                                <button type="button" class="js-filters-cancel filters-cancel button-text" @click="cancelFilter">Cancel
                                </button>
                                <button type="button" @click="applyFilter()"
                                        class="button-text text-white h-50px w-150px bg-purple btn-shadow btn border-50">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </form>
                  </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Veeno from 'veeno';
import DatePicker from 'vue2-datepicker';
import axios from 'axios'

export default {
    name: "Filters",
    props: ['bids', 'url', 'filterBudget', 'mode', 'unicArtistRanking', 'priceValue'],
    components: {
        Veeno, DatePicker
    },
    data() {
        return {
            cloneBids: this.bids,
            filterBids: [],
            filter: {
                sound: null,
                min: this.filterBudget.min,
                max: this.filterBudget.max,
                location: null,
                lat: null,
                lon: null,
                radius: 100,
                date: null,
                bring_equipment: false,
            },
            filterArtist: {
                min: this.filterBudget.min,
                max: this.filterBudget.max,
                artistRanking: null,
                fanBaseValue: null,
            },
            errors: {},
            show: false,
            width: 0
        }
    },
    mounted() {
        setTimeout(() => {
            this.initPlaceApi()
        }, 700)
    },

    methods: {
        applyFilter() {
            let vm = this,
                fl = vm.filter;
            axios.get(vm.url + '/filter/' + fl.sound + '/' + fl.min + '/'
                + fl.max + '/' + fl.lat + '/' + fl.lon + '/' + fl.radius + '/' + fl.date + '/' + fl.bring_equipment).then(function (response) {
                let data = response.data
                vm.filter.min = data.min
                vm.filter.max = data.max
                vm.$emit('filter', data.bids)
                vm.$emit('update:isVisbleFilter', vm.show)
            })
        },

        applyArtistFilter() {
            this.$emit('update:minPrice', this.filter.min)
            this.$emit('update:maxPrice', this.filter.max)
            this.$emit('update:fanBase', this.filterArtist.fanBaseValue)
            this.$emit('update:artistRanking', this.filterArtist.artistRanking)
            this.$emit('submitFilter')
        },

        clearFilter() {
            this.filter = {
                sound: null,
                min: this.filterBudget.min,
                max: this.filterBudget.max,
                location: null,
                lat: null,
                lon: null,
                radius: 100,
                date: null,
                equipment: false,
            }
        },

        clearArtistFilter() {
            this.filterArtist = {
                artistRanking: null,
                fanBaseValue: null
            },
            this.filter = {
                min: this.filterBudget.min,
                max: this.filterBudget.max
            }
            this.$emit('update:fanBase', this.filterArtist.fanBaseValue)
            this.$emit('update:artistRanking', this.filterArtist.artistRanking)
            this.$emit('submitFilter')
        },

        sliderEvent() {
            let vm = this;

            vm.filter.min = parseInt($('.noUi-handle-lower').attr('aria-valuetext')) - 1;
            vm.filter.max = parseInt($('.noUi-handle-upper').attr('aria-valuetext')) + 1;
        },

        initPlaceApi() {
            let vm = this;
            let placeElement = this.$refs.location
            if (placeElement) {
                let autocomplete = new google.maps.places.Autocomplete(placeElement, {
                    types: ['(regions)'],
                    componentRestrictions: {country: 'us'}
                });
                autocomplete.addListener('place_changed', function () {
                    let place = autocomplete.getPlace();
                    let latitude = place.geometry.location.lat();
                    let longitude = place.geometry.location.lng();
                    vm.filter.location = place.formatted_address
                    vm.filter.lat = latitude;
                    vm.filter.lon = longitude;
                });
            }
        },

        artistsRanking (value){
            this.filterArtist.artistRanking = value
        },

        updateWidth() {
            this.width = window.innerWidth;
        },
        customNumberInit() {
            window.__customNumberInit()
        },
        cancelFilter() {
            this.$emit('update:isVisbleFilter', this.show)
        }
    },
    created() {
        window.addEventListener('resize', this.updateWidth)
    },
}

</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
.form-check-input {
    padding-left: 30px !important;
}

.scroll-blocks-input {
    height: auto !important;
}

.filters-popup {
    display: block;
    z-index: 1049;
}

@media (max-width: 1200px) {
    .filters-popup {
        display: block;
        z-index: 1049;
        position:fixed;
        width:100%;
        height:100%;
        background:rgb(85 85 85 / 70%);
    }
}
</style>
